import React from 'react'

import {
  FAILED,
  NOT_WATERMARKED,
  PROCESSING,
  WATERMARK_REMOVED,
  WATERMARKED,
} from '@disco/constants/WatermarkStatusesTypes'
import { Trans } from '@disco/i18n/trans'

import ContactUsLink from 'components/ui/contact-us-link'
import type { IconKey } from 'components/ui/icon'
import type { LozengeColor } from 'components/ui/lozenge'

import type { Translate } from './types'

const playlistOptions: {
  failed: (t: Translate) => {
    color: LozengeColor
    text: string
    shortText: string
    tooltip: React.ReactNode
  }
  not_watermarked: (t: Translate) => {
    color: LozengeColor
    icon: IconKey
    text: string
    tooltip: React.ReactNode
  }
  processing: (t: Translate) => {
    color: LozengeColor
    text: string
    shortText: string
    tooltip: string
  }
  watermark_removed: (t: Translate) => {
    color: LozengeColor
    strikethrough: boolean
    text: string
    shortText: string
    tooltip: string
  }
  watermarked: (t: Translate) => {
    color: LozengeColor
    text: string
    shortText: string
  }
} = {
  [WATERMARKED](t) {
    return {
      color: 'blue',
      text: t('common:watermarked', 'Watermarked'),
      shortText: t('common:watermarkedAbbreviation', 'W'),
    }
  },

  [WATERMARK_REMOVED](t) {
    return {
      color: 'yellow',
      strikethrough: true,
      text: t('common:watermarked', 'Watermarked'),
      shortText: t('common:watermarkedAbbreviation', 'W'),
      tooltip: t(
        'common:thisPlaylistWasWatermarkedPreviously',
        'This playlist was watermarked previously but is currently not watermarked.',
      ),
    }
  },

  [NOT_WATERMARKED](t) {
    return {
      color: 'yellow',
      icon: 'warning',
      text: t('common:notWatermarked', 'Not watermarked'),
      tooltip: (
        <Trans
          t={t}
          i18nKey="common:thisPlaylistIsNotWatermarked"
          defaults="This playlist is not watermarked and contains a track that is part of an active watermarked playlist.<more>Find out more</more>"
          components={{
            more: <a className="WatermarkingStatusFlag_Link" href="#" />,
          }}
        />
      ),
    }
  },

  [FAILED](t) {
    return {
      color: 'bold-red',
      text: t('common:failed', 'Failed'),
      shortText: t('common:failedAbbreviation', 'F'),
      tooltip: (
        <Trans
          t={t}
          i18nKey="common:watermarkingForThisPlaylistFailed"
          defaults="Watermarking for this playlist failed. Please <contact>contact us</contact> for assistance"
          components={{
            contact: (
              <ContactUsLink intercomMsg="I’m having issues with watermarking failing on a playlist" />
            ),
          }}
        />
      ),
    }
  },

  [PROCESSING](t) {
    return {
      color: 'bold-green',
      text: t('common:processing', 'Processing'),
      shortText: t('common:processingAbbreviation', 'P'),
      tooltip: t(
        'common:watermarkingForThisPlaylistIsStillInProgress',
        'Watermarking for this playlist is still in progress.',
      ),
    }
  },
}
export default playlistOptions
